/**
 * Management → Company Profile。
 * 打开页面打 STATSIG.COMMON.VIEW，value=mgmt_company_profile。
 *
 * 正在用：公司信息表单，点 Submit 落库。
 * 已不算：改字段、上传/裁剪 logo、部分租户的展示开关（随 Submit 一起保存）。
 * 非 Owner 侧边栏的 Profile 是另一页，不跨过来。
 */
export enum MgmtCompanyProfileEvent {
    /** 点 Submit，更新公司资料 */
    UPDATE = 'COMPANY_PROFILE_UPDATE',
}
